import { render } from "./InventarioEstadoRatio.vue?vue&type=template&id=64db8fa8&scoped=true"
import script from "./InventarioEstadoRatio.vue?vue&type=script&lang=js"
export * from "./InventarioEstadoRatio.vue?vue&type=script&lang=js"

import "./InventarioEstadoRatio.vue?vue&type=style&index=0&id=64db8fa8&scoped=true&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64db8fa8"]])

export default __exports__